"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserAssociationsContext = exports.useAssociationsContext = exports.AssociationsProvider = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var next_api_swr_1 = require("@newfront-insurance/next-api-swr");
var react_1 = __importStar(require("react"));
var routes_1 = require("../bff/routes");
var apiRoutes = (0, routes_1.createApiRoutes)('/api/files');
var getAssociationsUrl = function (associations) { return apiRoutes.getAssociations(associations); };
var _a = (0, next_api_swr_1.createNextApiProvider)(getAssociationsUrl), AssociationsContextProvider = _a[0], useAssociations = _a[1];
function AssociationsProvider(props) {
    var associations = props.associations, children = props.children;
    return (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(core_ui_1.CircleSpinnerInline, { label: "Loading file associations..." }) },
        react_1.default.createElement(AssociationsContextProvider, { variables: associations }, children)));
}
exports.AssociationsProvider = AssociationsProvider;
var useAssociationsContext = function () {
    var contexts = useAssociations();
    return contexts
        .filter(function (context) { return context.displayName; })
        .map(function (context) { return (__assign({}, context)); });
};
exports.useAssociationsContext = useAssociationsContext;
var useUserAssociationsContext = function () {
    var contexts = useAssociations();
    return contexts
        .filter(function (context) { return context.displayName; })
        .map(function (context) { return (__assign({}, context)); });
};
exports.useUserAssociationsContext = useUserAssociationsContext;
